export const VimplayData = {
  TechnoRoulette: {
    redirectUrl: "/casino/vimplayvimplay-techno-roulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/texhnoroulette.jpg",
    alt: "TECHNO ROULETTE",
    name: "TECHNO ROULETTE",
    providerName: "Vimplay",
  },
  RoyalRoulette: {
    redirectUrl: "/casino/vimplayvimplay-royal-roulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/RoyalRoulette.jpg",
    alt: "ROYAL ROULETTE",
    name: "ROYAL ROULETTE",
    providerName: "Vimplay",
  },
  ReplayRoullete: {
    redirectUrl: "/casino/vimplayvimplay-replay-roulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/ReplayRoullete.jpg",
    alt: "REPLAY ROULETTE",
    name: "REPLAY ROULETTE",
    providerName: "Vimplay",
  },
  CosmicRoulette: {
    redirectUrl: "/casino/vimplayvimplay-cosmic-roulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/cosmicroulette.jpg",
    alt: "COSMIC ROULETTE",
    name: "COSMIC ROULETTE",
    providerName: "Vimplay",
  },
  Rouletto: {
    redirectUrl: "/casino/vimplayvimplay-rouletto",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/rouletto.jpg",
    alt: "ROULETTO",
    name: "ROULETTO",
    providerName: "Vimplay",
  },
  BombRunner: {
    redirectUrl: "/casino/vimplayvimplay-bombrunner",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/BombRun.jpg",
    alt: "BOMB_RUNNER",
    name: "BOMB_RUNNER",
    providerName: "Vimplay",
  },
  WishingWell: {
    redirectUrl: "/casino/vimplayvimplay-wishingwell",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/Wishingwell.jpg",
    alt: " WISHING_WELL",
    name: " WISHING_WELL",
    providerName: "Vimplay",
  },
  CrashKick: {
    redirectUrl: "/casino/vimplayvimplay-crash-kick",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/crashkick.jpg",
    alt: "CRASH KICK",
    name: "CRASH KICK",
    providerName: "Vimplay",
  },
  LottoLuck: {
    redirectUrl: "/casino/vimplayvimplay-lottoluck",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/lottoluck.jpg",
    alt: "LOTTO_LUCK",
    name: "LOTTO_LUCK",
    providerName: "Vimplay",
  },
  DragonTap: {
    redirectUrl: "/casino/vimplayvimplay-dragontap",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/dragontap.jpg",
    alt: "DRAGON_TAP",
    name: "DRAGON_TAP",
    providerName: "Vimplay",
  },
  Hhoorcold: {
    redirectUrl: "/casino/vimplayvimplay-hotorcold",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/HOTORCOLD.webp",
    alt: "HOT_OR_COLD",
    name: "HOT_OR_COLD",
    providerName: "Vimplay",
  },
  FateFlip: {
    redirectUrl: "/casino/vimplayvimplay-fate-flip",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/FATEFLIP.webp",
    alt: "FATE FLIP",
    name: "FATE FLIP",
    providerName: "Vimplay",
  },
  SpinnyWinny: {
    redirectUrl: "/casino/vimplayvimplay-spinnywinny",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/Spinnywinny.jpg",
    alt: "SPINNY_WINNY",
    name: "SPINNY_WINNY",
    providerName: "Vimplay",
  },
  Tossboss: {
    redirectUrl: "/casino/vimplayvimplay-tossboss",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/TOSSBOSS.webp",
    alt: "TOSS_BOSS",
    name: "TOSS_BOSS",
    providerName: "Vimplay",
  },
  Paradice: {
    redirectUrl: "/casino/vimplayvimplay-paradice",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/paradice.jpg",
    alt: "PARADICE",
    name: "PARADICE",
    providerName: "Vimplay",
  },
  pirateMines: {
    redirectUrl: "/casino/vimplayvimplay-piratemines",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/piratemines.jpg",
    alt: "PIRATE_MINES",
    name: "PIRATE_MINES",
    providerName: "Vimplay",
  },
  SpaceRaiders: {
    redirectUrl: "/casino/vimplayvimplay-space-raiders",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/spaceraiders.jpg",
    alt: "Space Raiders",
    name: "Space Raiders",
    providerName: "Vimplay",
  },
  Aladdin: {
    redirectUrl: "/casino/vimplayvimplay-aladdin",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/ALADDIN.webp",
    alt: "ALADDIN",
    name: "ALADDIN",
    providerName: "Vimplay",
  },
  TinyRoulette: {
    redirectUrl: "/casino/vimplayvimplay-tinyroulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/tiny_Roulette.jpg",
    alt: "TINY_ROULETTE",
    name: "TINY_ROULETTE",
    providerName: "Vimplay",
  },
  LuckyLine: {
    redirectUrl: "/casino/vimplayvimplay-luckyline",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/luckyline.jpg",
    alt: "LUCKY_LINE",
    name: "LUCKY_LINE",
    providerName: "Vimplay",
  },
  DiamondMine: {
    redirectUrl: "/casino/vimplayvimplay-diamondmine",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/DiamondMine.jpg",
    alt: "DIAMOND_MINE",
    name: "DIAMOND_MINE",
    providerName: "Vimplay",
  },
  Aquakeno: {
    redirectUrl: "/casino/vimplayvimplay-aquakeno",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/Aquakeno.jpg",
    alt: "AQUA_KENO",
    name: "AQUA_KENO",
    providerName: "Vimplay",
  },
  Magical: {
    redirectUrl: "/casino/vimplayvimplay-aladdin",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/magical.jpg",
    alt: "Magic Aladdin",
    name: "Magic Aladdin",
    providerName: "Vimplay",
  },
  SakuraRoulette: {
    redirectUrl: "/casino/vimplayvimplay-sakuraroulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/Sakura.jpg",
    alt: "Sakura Roulette",
    name: "Sakura Roulette",
    providerName: "Vimplay",
  },
  Shaktiman: {
    redirectUrl: "/casino/vimplayvimplay-shaktimaan",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/Shaktiman.jpg",
    alt: "Shaktimaan",
    name: "Shaktimaan",
    providerName: "Vimplay",
  },
  MonacoRoulette: {
    redirectUrl: "/casino/vimplayvimplay-monacoroulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/MonacoRoulette.jpg",
    alt: "Monaco Roulette",
    name: "Monaco Roulette",
    providerName: "Vimplay",
  },
  ArabicRoulette: {
    redirectUrl: "/casino/vimplayvimplay-arabicroulette",
    code: "",
    casino: "Vimplay",
    provider: "Vimplay",
    homeUrl: "http://localhost:3000/Casino",
    imgUrl: "./images/vimplay/Arabicroulette.jpg",
    alt: "Arabic Roulette",
    name: "Arabic Roulette",
    providerName: "Vimplay",
  },
};
